import React, { createContext, useState, useEffect } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  // 从 sessionStorage 中加载用户
  useEffect(() => {
    try {
      const savedUser = sessionStorage.getItem("user");
      if (savedUser) {
        setUser(JSON.parse(savedUser));
      }
    } catch (error) {
      console.error("Error loading user from sessionStorage:", error);
    }
  }, []);

  const loginUser = (userInfo) => {
    try {
      // 创建一个新的对象，去掉 password 字段
      const { password, ...userWithoutPassword } = userInfo;
      setUser(userWithoutPassword);
      sessionStorage.setItem("user", JSON.stringify(userWithoutPassword));
    } catch (error) {
      console.error("Error saving user to sessionStorage:", error);
    }
  };

  const logoutUser = () => {
    try {
      setUser(null);
      sessionStorage.removeItem("user");
    } catch (error) {
      console.error("Error removing user from sessionStorage:", error);
    }
  };

  return (
    <UserContext.Provider
      value={{
        user,
        loginUser,
        logoutUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = React.useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
